<template>
  <v-form ref="form" v-bind="this.$attrs">
    <div class="filter-wrapper">
      <div class="filter-options">
        <v-row>
          <v-col cols="12" md="4" class="pb-0">
            <AutocompleteMonth label="Tháng" v-model="month" dense outlined />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <GradeClassStudentSelect @changed="gradeClassStudentChange" />
          </v-col>
        </v-row>
      </div>
      <div class="filter-submit">
        <v-btn class="search-button" dark @click="onFilterChanged" outlined>
          Tìm kiếm
        </v-btn>
      </div>
    </div>
  </v-form>
</template>

<script>
import { get } from 'lodash'
import AutocompleteMonth from '@/components/basic/input/AutocompleteMonth.vue'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: {
    AutocompleteMonth,
    GradeClassStudentSelect
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: {},
    month: null
  }),
  methods: {
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    onFilterChanged() {
      if (!this.$refs.form.validate() || !this.month.date) return

      const params = {
        date: this.month.date,
        grade: get(this.selectedGrade, 'id'),
        class: get(this.selectedClass, 'id'),
        student: get(this.selectedStudent, 'id')
      }
      this.$emit('onFilterChanged', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
